import React from 'react';
import { motion } from 'framer-motion';
export function GrowthVisualization({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative w-full h-full ${className}`} data-id="element-166">
      <svg viewBox="0 0 400 200" className="w-full h-full opacity-30" data-id="element-167">
        {/* Grid Lines */}
        <g stroke="#00e5ff" strokeWidth="1" strokeOpacity="0.1" data-id="element-168">
          <line x1="0" y1="150" x2="400" y2="150" data-id="element-169" />
          <line x1="0" y1="100" x2="400" y2="100" data-id="element-170" />
          <line x1="0" y1="50" x2="400" y2="50" data-id="element-171" />
        </g>

        {/* Area Gradient */}
        <defs data-id="element-172">
          <linearGradient id="areaGlow" x1="0" y1="0" x2="0" y2="1" data-id="element-173">
            <stop offset="0%" stopColor="#00e5ff" stopOpacity="0.3" data-id="element-174" />
            <stop offset="100%" stopColor="#00e5ff" stopOpacity="0" data-id="element-175" />
          </linearGradient>
        </defs>

        {/* Animated Line */}
        <motion.path d="M0 180 L80 140 L160 150 L240 90 L320 110 L400 40" fill="none" stroke="#00e5ff" strokeWidth="3" initial={{
        pathLength: 0
      }} whileInView={{
        pathLength: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-176" />

        {/* Animated Area */}
        <motion.path d="M0 180 L80 140 L160 150 L240 90 L320 110 L400 40 L400 200 L0 200 Z" fill="url(#areaGlow)" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 2,
        delay: 0.5
      }} data-id="element-177" />

        {/* Data Points */}
        {[{
        cx: 80,
        cy: 140,
        delay: 0.4
      }, {
        cx: 160,
        cy: 150,
        delay: 0.8
      }, {
        cx: 240,
        cy: 90,
        delay: 1.2
      }, {
        cx: 320,
        cy: 110,
        delay: 1.6
      }, {
        cx: 400,
        cy: 40,
        delay: 2.0
      }].map((point, i) => <motion.circle key={i} cx={point.cx} cy={point.cy} r="4" fill="#fff" className="shadow-[0_0_10px_#00e5ff]" initial={{
        scale: 0,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: point.delay,
        type: 'spring'
      }} data-id="element-178" />)}
      </svg>
    </div>;
}